import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

/* images */
import iconIndex from "./../../assets/images/header/iconIndex.jpg";
import iconLink from "./../../assets/images/header/iconLink.jpg";

const Header = () => {
  const dropdownContent = (links) => (
    <div className="dropdown-content">
      {links.map((link, index) => (
        <Link key={index} to={link.href}>
          {link.text}
        </Link>
      ))}
    </div>
  );

  const sigaLinks = [
    { href: "/siga/01", text: "Wolfram Alpha" },
    { href: "/siga/02", text: "Google Colab" },
    { href: "/siga/03", text: "Audacity" },
    { href: "/siga/04", text: "Sinus und Kosinus" },
    { href: "/siga/05", text: "Faltung" },
    { href: "/siga/06", text: "DFT" },
    { href: "/siga/07", text: "Gleitender Mittelwert" },
    { href: "/siga/08", text: "Abtasttheorem" },
    { href: "/siga/09", text: "Leakage" },
    { href: "/siga/10", text: "Tierstimmen" },
    { href: "/siga/11", text: "Erwartungswert und Varianz" },
    { href: "/siga/12", text: "Verteilungen" },
    { href: "/siga/13", text: "Stichprobe" },
    { href: "/siga/14", text: "Gezinkte Würfel" },
    { href: "/siga/15", text: "Korrelationskoeffizient" }
  ];

  const bvLinks = [
    { href: "/bv/01", text: "Thema 01" },
    { href: "/bv/02", text: "Thema 02" },
    { href: "/bv/03", text: "Thema 03" },
    { href: "/bv/04", text: "Thema 04" },
    { href: "/bv/05", text: "Thema 05" },
    { href: "/bv/06", text: "Thema 06" },
    { href: "/bv/07", text: "Thema 07" },
    { href: "/bv/08", text: "Thema 08" },
    { href: "/bv/09", text: "Thema 09" },
    { href: "/bv/10", text: "Thema 10" },
    { href: "/bv/11", text: "Thema 11" },
    { href: "/bv/12", text: "Thema 12" }
  ];

  return (
    <header>
      <a href="/">
        <img src={iconIndex} alt="Website Logo" />
      </a>
      <div className="gridContainer">
        <div className="dropdown">
          <button className="dropbtn">SIGA</button>
          {dropdownContent(sigaLinks)}
        </div>
        <div className="dropdown">
          <button className="dropbtn">BV</button>
          {dropdownContent(bvLinks)}
        </div>
      </div>
      <a href="/links">
        <img src={iconLink} alt="Link Icon" />
      </a>
    </header>
  );
};

export default Header;